angular.module("Crm.BtnSignature.Controller", ["transactionsService.Service"]).controller("SignatureBtnCtrl", ["$scope", "$uibModal", "Contrat", "ConfigsCommercialisateurs", "Signatures", "$rootScope", "CheckSignatureRequirements", "DocumentsProcedure", "Transactions", "TransactionUnlatch", function ($scope, $uibModal, Contrat, ConfigsCommercialisateurs, Signatures, $rootScope, CheckSignatureRequirements, DocumentsProcedure, Transactions, TransactionUnlatch) {
  var self = this;

  self.$onInit = () => {
    ConfigsCommercialisateurs.getConfigCommercialisateurs().then(function (response) {
      self.configCommercialisateursTransactions = response.data;
    }).catch(function (error) {
      console.log(error);
    });

    if (this.isCheckSignatureRequirements && this.transaction.contrat_reservation_id) {
      this.checkSignatureRequirements();
      this.getProcedure(this.transaction);
    }
  };

  $scope.status = {
    isopen: false
  };

  this.checkSignatureRequirements = () => {
    this.btnSignatureDisabled = true;
    CheckSignatureRequirements.get({
      documentId: this.transaction.contrat_reservation_id
    }).$promise.then(response => {
      this.signatureRequirements = response;
      this.btnSignatureDisabled = !response.valid;
    }).catch(error => {
      const er = error && error.data && error.data.message ? error.data.message : error;
      console.log("error : ", er);
    });
  };

  $scope.$on("contratGenerer", (event, newTransaction) => {
    if (newTransaction && this.isCheckSignatureRequirements && this.transaction.contrat_reservation_id && this.transaction.id === newTransaction.id) {
      if (newTransaction.contrat_reservation_id) {
        this.transaction.contrat_reservation_id = newTransaction.contrat_reservation_id;
      }

      this.transaction.signature_procedure_status = newTransaction.signature_procedure_status;
      this.checkSignatureRequirements();
    }
  });
  $scope.$on("contratRegenerer", (event, newTransaction) => {
    if (newTransaction && this.isCheckSignatureRequirements && this.transaction.contrat_reservation_id && this.transaction.id === newTransaction.id) {
      if (newTransaction.contrat_reservation_id) {
        this.transaction.contrat_reservation_id = newTransaction.contrat_reservation_id;
      }

      this.transaction.signature_procedure_status = newTransaction.signature_procedure_status;
      this.checkSignatureRequirements();
    }
  });
  $scope.$on("signatureAbandonnee", (event, transaction) => {
    if (transaction && this.isCheckSignatureRequirements && this.transaction.contrat_reservation_id && this.transaction.id === transaction.id) {
      this.checkSignatureRequirements();
    }
  });
  /**
   * Notification contrat_generer on a besoin de mettre à jour les infos de transaction pour télécharger le bon PDF.
   */

  $scope.$on("notification_contrat_generer", (event, data) => {
    if (!this.isNotificationContratGenerer || !data || !data.transactionId || data.transactionId !== this.transaction.id) {
      return;
    }

    this.getTransaction(data.transactionId);
  });

  self.voirContrat = function () {
    if (this.transaction.processus_generating !== 50) {
      return;
    }

    var maWindow = window.open();
    Contrat.get({
      documentId: this.transaction.contrat_reservation_id
    }).$promise.then(function (response) {
      if (response.document_url) {
        maWindow.location.href = response.document_url;
      }
    });
  };

  self.voirDocx = function (transaction) {
    if (this.transaction.processus_generating !== 50) {
      return;
    }

    var maWindow = window.open(); //Récupération document généré

    return Contrat.get({
      documentId: transaction.contrat_reservation_id
    }).$promise.then(function (response) {
      if (response.document_docx) {
        maWindow.location.href = response.document_docx;
      }
    });
  };

  this.telechargerAR24 = procedure => {
    this.openUrl(procedure.proof);
  };

  this.signature = transaction => {
    if (this.transaction.processus_generating !== 50) {
      return;
    }

    let documentSigne = new Signatures();
    documentSigne.transaction_document_id = transaction.contrat_reservation_id;
    return documentSigne.$save().then(response => {
      transaction.contrat_reservation_envoye_id = response.id;
      transaction.contrat_demande_id = response.demand_id;
      transaction.contrat_date_initialisation = response.initialized_date;
      this.getProcedure(transaction);
      this.modalInfoSignature({
        title: "Information",
        texte: "Le contrat a été envoyé au(x) client(s) pour signature"
      });
      $rootScope.$broadcast("signatureDemandeEffectuee");
    }, function (error) {
      $rootScope.$broadcast("toasterError", error.data.message);
    });
  };

  this.signatureEResa = transaction => {
    if (transaction.url_signature_unlatch) {
      this.openUrl(transaction.url_signature_unlatch);
      return;
    }

    transaction.loadingUnlatch = true;
    TransactionUnlatch.get({
      transactionId: transaction.id
    }).$promise.then(response => {
      transaction.loadingUnlatch = false;

      if (response && response.editionUrl) {
        transaction.url_signature_unlatch = response.editionUrl;
        this.openUrl(response.editionUrl);
      }
    }).catch(error => {
      transaction.loadingUnlatch = false;
      console.log(error);
    });
  };

  this.openUrl = url => {
    const maWindow = window.open();
    maWindow.location.href = url;
  };

  this.getProcedure = transaction => {
    DocumentsProcedure.get({
      transactionId: transaction.id,
      documentId: transaction.contrat_reservation_id
    }).$promise.then(response => {
      if (response && response.signature_procedure_status && transaction.signature_procedure_status != 2) {
        transaction.signature_procedure_status = response.signature_procedure_status;
      }

      transaction.procedure = response;
    }).catch(error => {
      console.log(error);

      if (error.data && error.data.message) {
        $rootScope.$broadcast("toasterError", error.data.message);
      }
    });
  };

  this.telechargerContratSigne = transaction => {
    this.openUrl(transaction.contract_signed_document_url);
  };
  /*
   * Modal
   */


  this.openModalAbandonnerSignatures = function (transaction) {
    if (self.configCommercialisateursTransactions && !self.configCommercialisateursTransactions.contrat_reservation_signature_enabled) {
      return false;
    }

    var modalInstance = $uibModal.open({
      templateUrl: "src/btn-signature/modal-abandonner-transaction.html",
      controller: "abandonnerSignatureModalCtrl",
      controllerAs: "$ctrl",
      resolve: {
        transaction: function () {
          return transaction;
        },
        filtresTransactions: function () {
          return self.filtresTransactions;
        }
      }
    });
  };

  this.openModalVoirContrat = function (docUrl) {
    let modalContrat = $uibModal.open({
      windowTemplateUrl: "src/btn-signature/modal-window-lg.html",
      templateUrl: "src/btn-signature/modal-contrat.html",
      controller: "modalContratCtrl",
      controllerAs: "$ctrl",
      resolve: {
        docUrl: () => {
          return docUrl;
        }
      }
    });
  };

  this.openModalContrat = function () {
    let modalContrat = $uibModal.open({
      windowTemplateUrl: "src/btn-signature/modal-window-lg.html",
      templateUrl: "src/btn-signature/modal-contrat.html",
      controller: "modalContratCtrl",
      controllerAs: "$ctrl",
      resolve: {
        docUrl: () => {
          return this.transaction.signature_procedure_status === 20 ? this.myValidator.validation_url : this.myReservant.validation_url;
        }
      }
    }).closed.then(() => {
      const transactions = new Transactions({});
      transactions.removeCache();
      $rootScope.$broadcast("actualiserTransactions");
    });
  };

  this.modalAbandonnerSignature = transaction => {
    var modalInstance = $uibModal.open({
      templateUrl: "src/btn-signature/modal-abandonner-signature.html",
      controller: "abandonnerSignatureModalCtrl",
      controllerAs: "$ctrl",
      resolve: {
        transaction: () => {
          return transaction;
        }
      }
    });
  };

  this.modalInfoSignature = params => {
    var modalInstance = $uibModal.open({
      windowTemplateUrl: "src/modal/modal-window-lg.html",
      templateUrl: "src/modal/modal.html",
      controller: "ModalCtrl",
      controllerAs: "$ctrl",
      resolve: {
        params: () => {
          return params;
        }
      }
    });
  };

  this.modalStartContrat = (transaction, regenererContrat, isSignatureBtn) => {
    if (self.configCommercialisateursTransactions && !self.configCommercialisateursTransactions.contrat_reservation_generate_enabled || !transaction.isTemplateAvailable) {
      return false;
    }

    var modalInstance = $uibModal.open({
      templateUrl: "src/btn-signature/modal-start-contrat.html",
      controller: "modalStartContratCtrl",
      controllerAs: "$ctrl",
      resolve: {
        transaction: () => {
          return transaction;
        },
        regenererContrat: () => {
          return regenererContrat;
        },
        isSignatureBtn: () => {
          return isSignatureBtn;
        }
      }
    });
  };

  this.getTransaction = transactionId => {
    Transactions.get({
      id: transactionId
    }).$promise.then(transaction => {
      this.transaction.contrat_reservation_id = transaction.contrat_reservation_id;
      this.transaction.processus_generating = transaction.processus_generating;

      if (this.transaction.contrat_reservation_id) {
        this.checkSignatureRequirements();
        this.getProcedure(this.transaction);
      }
    }).catch(error => {
      console.log("error : ", error);
    });
  };
}]).controller("modalStartContratCtrl", ["transaction", "regenererContrat", "$uibModal", "$uibModalInstance", function (transaction, regenererContrat, $uibModal, $uibModalInstance) {
  this.valider = () => {
    $uibModalInstance.close();
    this.openModalGenererContrat(transaction, regenererContrat);
  };

  this.openModalGenererContrat = function (transaction, regenererContrat) {
    if (self.configCommercialisateursTransactions && !self.configCommercialisateursTransactions.contrat_reservation_generate_enabled) {
      return false;
    }

    $uibModal.open({
      windowTemplateUrl: "src/btn-signature/modal-window-fullscreen-vertical.html",
      templateUrl: "src/btn-signature/modal-generer-contrat.html",
      controller: "genererContratModalCtrl",
      controllerAs: "$ctrl",
      backdrop: "static",
      resolve: {
        contact: ["Contacts", function (Contacts) {
          return Contacts.get({
            contactId: transaction.client_id
          }).$promise.then(function successCallback(response) {
            return response;
          }, function errorCallback(response) {
            console.log("Erreur factory Contacts get : " + response);
            return false;
          });
        }],
        lot: ["Lot", function (Lot) {
          return Lot.get({
            lotId: transaction.lot_id,
            lots_annexes: 1
          }).$promise.then(function successCallback(response) {
            return response;
          }, function errorCallback(response) {
            console.log("Erreur factory Lot get : " + response);
            return false;
          });
        }],
        transactionDetails: ["Transactions", function (Transactions) {
          return Transactions.get({
            id: transaction.id
          }).$promise.then(function successCallback(response) {
            return response;
          }, function errorCallback(response) {
            console.log("Erreur factory Transactions get : " + response);
            return false;
          });
        }],
        transaction: function () {
          return transaction;
        },
        regenererContrat: function () {
          return regenererContrat;
        },
        infosDocument: ["Contrat", function (Contrat) {
          if (regenererContrat) {
            return Contrat.get({
              documentId: transaction.contrat_reservation_id
            }).$promise.then(function successCallback(response) {
              return response;
            }, function errorCallback(response) {
              console.log("Erreur factory contrat get : ", response);
              return false;
            });
          }

          return false;
        }],
        filtresTransactions: function () {
          return self.filtresTransactions;
        }
      }
    });
  };
}]).controller("modalContratCtrl", ["docUrl", "$sce", function (docUrl, $sce) {
  this.$onInit = () => {
    this.docUrl = $sce.trustAsResourceUrl(docUrl);
  };
}]).controller("abandonnerSignatureModalCtrl", ["$uibModalInstance", "transaction", "Signatures", "$rootScope", function ($uibModalInstance, transaction, Signatures, $rootScope) {
  this.transaction = transaction;

  this.valider = () => {
    var signature = new Signatures({
      id: transaction.contrat_reservation_id
    });
    return signature.$delete().then(response => {
      transaction.signature_procedure_status = -30; // status : annuler/refuser

      $rootScope.$broadcast("signatureAbandonnee", transaction);
      $uibModalInstance.close();
    }, error => {
      $rootScope.$broadcast("toasterError", error.message);
    });
  };
}]).controller("btnOpenModalGenererContratCtrl", [function () {
  $scope.$on("openModalGenererContrat", (event, obj) => {
    const matchType = this.btnType === "generer-contrat" && obj.regenererContrat === false || this.btnType === "re-generer-contrat" && obj.regenererContrat === true || obj.isSignatureBtn === "signature-btn";

    if (obj && obj.regenererContrat !== undefined && matchType && obj.transaction && obj.transaction.id === this.transaction.id) {
      this.openModalGenererContrat(obj.transaction, obj.regenererContrat);
    }
  });
}]);
angular.module("Crm.BtnSignature", ["Crm.BtnSignature.Controller", "Crm.btn-signature.templates"]).component("signatureBtn", {
  controller: "SignatureBtnCtrl",
  templateUrl: "src/btn-signature/signature-btn.html",
  bindings: {
    transaction: "=",
    addClass: "<",
    isCheckSignatureRequirements: "<",
    filtresTransactions: "<",
    myValidator: "<",
    myReservant: "<",
    isNotificationContratGenerer: "<?"
  }
}).component("btnGenererContrat", {
  controller: "SignatureBtnCtrl",
  templateUrl: "src/btn-signature/btn-generer-contrat.html",
  bindings: {
    transaction: "<",
    btnType: "<",
    isNotificationContratGenerer: "<?"
  }
}).component("btnReGenererContrat", {
  controller: "SignatureBtnCtrl",
  templateUrl: "src/btn-signature/btn-regenerer-contrat.html",
  bindings: {
    transaction: "<",
    btnType: "<",
    isNotificationContratGenerer: "<?"
  }
}).component("btnDemarrerSignature", {
  controller: "SignatureBtnCtrl",
  templateUrl: "src/btn-signature/btn-demarrer-signature.html",
  bindings: {
    transaction: "<",
    isCheckSignatureRequirements: "<",
    signatureRequirements: "=",
    isNotificationContratGenerer: "<?"
  }
}).component("btnValiderContrat", {
  controller: "SignatureBtnCtrl",
  templateUrl: "src/btn-signature/btn-valider-contrat.html",
  bindings: {
    transaction: "<",
    myValidator: "<",
    myReservant: "<",
    addClass: "<?",
    isNotificationContratGenerer: "<?"
  }
}).component("btnAbandonnerSignature", {
  controller: "SignatureBtnCtrl",
  templateUrl: "src/btn-signature/btn-abandonner-signature.html",
  bindings: {
    transaction: "<",
    isNotificationContratGenerer: "<?"
  }
});
angular.module('Crm.btn-signature.templates', []).run(['$templateCache', function($templateCache) {$templateCache.put('src/btn-signature/btn-abandonner-signature.html','<button class="btn btn-danger" ng-click="$ctrl.modalAbandonnerSignature($ctrl.transaction, true)" tooltip-placement="top" uib-tooltip="Fonctionnalit\xE9 non activ\xE9e" tooltip-enable="!$ctrl.configCommercialisateursTransactions.contrat_reservation_generate_enabled" ng-disabled="!$ctrl.configCommercialisateursTransactions.contrat_reservation_generate_enabled" ng-if="$ctrl.transaction.signature_procedure_status > 0 &&\r\n      $ctrl.transaction.signature_procedure_status <= 30 &&\r\n      $ctrl.transaction.contrat_reservation_id && \r\n      $root.membreConnecter.id === $ctrl.transaction.vendeur_id &&\r\n      $root.membreConnecter.is_partenaire === false" promise-btn> <span class="btn-text">Annuler contrat et signature</span></button>');
$templateCache.put('src/btn-signature/btn-demarrer-signature.html','<button class="btn btn-primary" ng-click="$ctrl.signature($ctrl.transaction)" tooltip-placement="top" uib-tooltip="Fonctionnalit\xE9 non activ\xE9e" tooltip-enable="!$ctrl.configCommercialisateursTransactions.contrat_reservation_signature_enabled" ng-disabled="!$ctrl.configCommercialisateursTransactions.contrat_reservation_signature_enabled || $ctrl.btnSignatureDisabled || $ctrl.transaction.processus_generating !== 50" ng-if="$ctrl.transaction.signature_procedure_status === 0 && $ctrl.transaction.contrat_reservation_id" promise-btn> <span class="btn-text">D\xE9marrer la signature</span></button>');
$templateCache.put('src/btn-signature/btn-generer-contrat.html','<button class="btn btn-tertiary btn-radius" ng-click="$ctrl.modalStartContrat($ctrl.transaction, false)" ng-if="$ctrl.transaction.contrat_reservation_id === 0 && $ctrl.transaction.type_id === 2 && $root.membreConnecter.is_partenaire === false && $ctrl.transaction.signature_procedure_status != 2" tooltip-placement="top" uib-tooltip="{{ !$ctrl.transaction.isTemplateAvailable ? \'Pas de contrat de r\xE9servation sur ce programme\' : \'Fonctionnalit\xE9 non activ\xE9e\' }}" tooltip-enable="!$ctrl.configCommercialisateursTransactions.contrat_reservation_generate_enabled || !$ctrl.transaction.isTemplateAvailable" ng-disabled="!$ctrl.configCommercialisateursTransactions.contrat_reservation_generate_enabled || !$ctrl.transaction.isTemplateAvailable" ng-class="!$ctrl.configCommercialisateursTransactions.contrat_reservation_generate_enabled || !$ctrl.transaction.isTemplateAvailable ? \'btn-tertiary\' : \'btn-primary\'"> G\xE9n\xE9rer le contrat</button>');
$templateCache.put('src/btn-signature/btn-regenerer-contrat.html','<button class="btn btn-primary" ng-click="$ctrl.modalStartContrat($ctrl.transaction, true)" tooltip-placement="top" uib-tooltip="Fonctionnalit\xE9 non activ\xE9e" tooltip-enable="!$ctrl.configCommercialisateursTransactions.contrat_reservation_generate_enabled" ng-disabled="!$ctrl.configCommercialisateursTransactions.contrat_reservation_generate_enabled" ng-if="$ctrl.transaction.contrat_reservation_id > 0 \r\n        && $ctrl.transaction.type_id === 2\r\n        && ($ctrl.transaction.signature_procedure_status === 0 || \r\n        $ctrl.transaction.signature_procedure_status === -30 ||\r\n        $ctrl.transaction.signature_procedure_status === -20)\r\n        && $root.membreConnecter.is_partenaire === false" promise-btn> <span class="btn-text">Reg\xE9n\xE9rer le contrat</span></button>');
$templateCache.put('src/btn-signature/btn-valider-contrat.html','<button class="btn btn-primary {{ $ctrl.addClass }}" ng-click="$event.stopPropagation(); $ctrl.openModalContrat()" ng-if="($ctrl.myValidator.status === \'active\' && $ctrl.transaction.signature_procedure_status === 20) || ($ctrl.myReservant.status === \'active\' && $ctrl.transaction.signature_procedure_status === 30)"> Valider/Refuser le contrat</button>');
$templateCache.put('src/btn-signature/modal-abandonner-signature.html','<div class="modal-header"> <button type="button" class="close" ng-click="$dismiss()"> <span>&times;</span></button><h3 class="modal-title h4" id="modal-title">Confirmation</h3></div><div class="modal-body" id="modal-body"> Voulez-vous annuler le contrat du lot <b>{{ $ctrl.transaction.lot_nom }}</b> du programme <b>{{ $ctrl.transaction.programme_nom }}</b> pour le client <b>{{ $ctrl.transaction.client_nom + \' \' + $ctrl.transaction.client_prenom}}</b> ?</div><div class="modal-footer"> <button class="btn btn-primary" type="button" ng-click="$close()"> Non</button> <button class="btn btn-danger" type="button" ng-click="$ctrl.valider()" promise-btn> <span class="btn-text">Oui</span></button></div>');
$templateCache.put('src/btn-signature/modal-contrat.html','<div class="modal-header"> <button type="button" class="close" ng-click="$dismiss()"> <span>&times;</span></button><h3 class="modal-title h4" id="modal-title">Contrat</h3></div><div class="modal-body" id="modal-body"><iframe ng-src="{{ $ctrl.docUrl }}" width="100%" height="600" frameborder="0"></iframe></div>');
$templateCache.put('src/btn-signature/modal-generer-contrat.html','<div class="modal-body signature" id="modal-body"><div class="alert alert-warning" ng-if="($ctrl.formValidAcquereur.$invalid ||\r\n    $ctrl.formValidCoAcquereur.$invalid || $ctrl.formObjPret1.$invalid) && $ctrl.isSubmit"><p ng-show="$ctrl.formValidAcquereur.$invalid"> Le formulaire de l\'acqu\xE9reur comporte une/des erreur(s).</p><p ng-show="$ctrl.formValidCoAcquereur.$invalid">Le formulaire du co-acqu\xE9reur comporte une/des erreur(s).</p><p ng-show="$ctrl.formObjPret1.$invalid">Le formulaire de pr\xEAt comporte une/des erreur(s).</p></div><div class="close-modal new-modal"> <button type="button" class="close" ng-click="$ctrl.annuler()"><span>&times;</span> annuler</button></div><div class="header-infos"><div class="modal-desc-lot"><div class="modal-desc-lot-item modal-desc-lot-title">Votre r\xE9servation:</div><div class="modal-desc-lot-item modal-desc-lot-ref">Lot <span>{{ $ctrl.lot.nom }}</span></div><div class="modal-desc-lot-item modal-desc-lot-detail"><div class="marker-detail nature"> {{ $ctrl.lot.nature }}</div><div class="marker-detail typo"> {{ $ctrl.lot.pieces }} pi\xE8ces</div><div class="marker-detail surface"> {{ $ctrl.lot.surface }} m<sup>2</sup></div><div class="marker-detail etage"> \xE9tage {{ $ctrl.lot.etage }}</div></div><div class="modal-desc-lot-item modal-desc-lot-montant"> {{ $ctrl.transactionDetails.prix | currency:$ctrl.lot.devise_unite:0 }}</div></div></div><div id="prev-next-nav" class="d-flex sign-form-btn"><div class="d-flex justify-content-between flex-1 mb-1 ml-1 mr-1 prev-next-nav-btn"><div class="d-flex"> <button ng-if="$ctrl.active != \'acquereurs\'" class="btn btn-secondary" type="button" ng-click="$ctrl.prevTab()"> <span class="text-btn">Retour</span><span class="icon-btn"><i class="fa fa-chevron-left"></i></span></button></div><div class="d-flex"> <button ng-if="$ctrl.active != \'generer_contrat\'" class="btn btn-primary" type="button" ng-click="$ctrl.nextTab()"> <span class="text-btn">Suivant</span><span class="icon-btn"><span class="icon-btn"><i class="fa fa-chevron-right"></i></span></span></button></div></div></div><uib-tabset active="$ctrl.active" justified="true" class="modal-body-content"><uib-tab index="\'acquereurs\'" heading="Acqu\xE9reurs"><ng-include src="\'src/signature/genererContrat/contact-conjoint-coacquereur.html\'"></ng-include></uib-tab><uib-tab index="\'financement\'" heading="Financement" ng-if="$ctrl.configsContratReservation.financement && $ctrl.configsContratReservation.financement === true"><ng-include src="\'src/signature/genererContrat/financement.html\'"></uib-tab><uib-tab index="\'depot_garantie\'" heading="D\xE9pot de garantie" ng-if="$ctrl.configsContratReservation.depot_garantie && $ctrl.configsContratReservation.depot_garantie === true"><ng-include src="\'src/signature/genererContrat/depot-garantie.html\'"></uib-tab><uib-tab index="\'pret\'" heading="Pr\xEAt"><ng-include src="\'src/signature/genererContrat/pret.html\'"></uib-tab><uib-tab index="\'notaire\'" heading="Notaire" ng-if="$ctrl.configsContratReservation.notaire && $ctrl.configsContratReservation.notaire === true"><ng-include src="\'src/signature/genererContrat/notaire.html\'"></uib-tab><uib-tab index="\'annexes\'" heading="Annexes"><ng-include src="\'src/signature/genererContrat/annexes.html\'"></uib-tab><uib-tab index="\'lot\'" heading="Lot"><ng-include src="\'src/signature/genererContrat/lot.html\'"></uib-tab><uib-tab index="\'fiscalite\'" heading="Fiscalit\xE9"><ng-include src="\'src/signature/genererContrat/fiscalite.html\'"></uib-tab><uib-tab index="\'generer_contrat\'" heading="G\xE9n\xE9rer le contrat"><ng-include src="\'src/signature/genererContrat/signature.html\'"></uib-tab></uib-tabset></div>');
$templateCache.put('src/btn-signature/modal-start-contrat.html','<div class="modal-body text-center" id="modal-body"><ul class="unstyled"><li class="uppercase bold">T\xE9l\xE9phone mobile</li><li class="bold">Adresse E.MAIL</li></ul><p class="mt-1"> sont n\xE9cessaires pour la signature \xE9lectronique CLIENT + VENDEUR</p><p class="mt-2"> Merci de v\xE9rifier l\'exactitude des donn\xE9es avant de lancer la proc\xE9dure.</p> <button class="btn btn-secondary mt-2" ng-click="$ctrl.valider()"> J\'ai compris</button></div>');
$templateCache.put('src/btn-signature/modal-window-fullscreen-vertical.html','<div class="modal-dialog modal-dialog-fullscreen vertical"><div class="modal-content" uib-modal-transclude></div></div>');
$templateCache.put('src/btn-signature/modal-window-fullscreen.html','<div class="modal-dialog modal-dialog-fullscreen"><div class="modal-content" uib-modal-transclude></div></div>');
$templateCache.put('src/btn-signature/modal-window-lg.html','<div class="modal-dialog " ng-class="{\'modal-lg modal-custom\' : $root.showModalLg, \'modal-lg\': $root.showModalLg === undefined}"><div class="modal-content" uib-modal-transclude></div></div>');
$templateCache.put('src/btn-signature/signature-btn.html',' <a class="btn btn-tertiary btn-radius d-flex d-flex-1 j-center align-center" title="G\xE9n\xE9rer le contrat" tooltip-placement="top" uib-tooltip="{{ !$ctrl.transaction.isTemplateAvailable ? \'Pas de contrat de r\xE9servation sur ce programme\' : \'Fonctionnalit\xE9 non activ\xE9e\' }}" tooltip-enable="!$ctrl.configCommercialisateursTransactions.contrat_reservation_generate_enabled || !$ctrl.transaction.isTemplateAvailable" ng-disabled="!$ctrl.configCommercialisateursTransactions.contrat_reservation_generate_enabled || !$ctrl.transaction.isTemplateAvailable" ng-click="$event.stopPropagation();$ctrl.modalStartContrat($ctrl.transaction, false, \'signature-btn\')" ng-if="$ctrl.transaction.contrat_reservation_id === 0 && $ctrl.transaction.type_id !== 1" ng-class="!$ctrl.configCommercialisateursTransactions.contrat_reservation_generate_enabled || !$ctrl.transaction.isTemplateAvailable ? \'btn-tertiary\' : \'btn-primary\'">G\xE9n\xE9rer le contrat</a><div ng-if="$ctrl.transaction.contrat_reservation_id !== 0 && $ctrl.transaction.signature_procedure_status != 2" class="d-flex"><div class="d-flex flex-1 {{ $ctrl.addClass }}" ng-if="$ctrl.transaction.type_id === 2" uib-dropdown is-open="status.isopen"> <button id="button-signature" type="button" class="btn btn-tertiary btn-radius d-flex d-flex-1 j-center align-center" uib-dropdown-toggle ng-disabled="disabled" ng-click="$event.stopPropagation();"> Signer<span class="caret"></span></button><ul class="dropdown-menu w-100" uib-dropdown-menu role="menu" aria-labelledby="button-signature" ng-if="$ctrl.transaction.signature_programme_unlatch !== true"><li role="menuitem" ng-if="$ctrl.transaction.contrat_reservation_id !== 0"> <a title="Voir le contrat" tooltip-placement="top" ng-click="$event.stopPropagation();$ctrl.voirContrat($ctrl.transaction)" ng-disabled="$ctrl.transaction.processus_generating !== 50">T\xE9l\xE9charger le PDF</a></li><li role="menuitem" ng-if="$ctrl.transaction.contrat_reservation_signe === 0\r\n              && $ctrl.transaction.contrat_reservation_envoye_id === 0\r\n              && $ctrl.transaction.contrat_reservation_id !== 0"> <a title="T\xE9l\xE9charger le docx" tooltip-placement="top" uib-tooltip="Fonctionnalit\xE9 non activ\xE9e" tooltip-enable="!$ctrl.configCommercialisateursTransactions.contrat_reservation_signature_enabled" ng-disabled="!$ctrl.configCommercialisateursTransactions.contrat_reservation_signature_enabled || $ctrl.transaction.processus_generating !== 50" ng-click="$event.stopPropagation();$ctrl.voirDocx($ctrl.transaction, true)">T\xE9l\xE9charger le docx</a></li><li role="menuitem" ng-if="$ctrl.transaction.procedure.ar.proof"> <a title="T\xE9l\xE9charger l\'AR24" tooltip-placement="top" ng-click="$event.stopPropagation();$ctrl.telechargerAR24($ctrl.transaction.procedure)">T\xE9l\xE9charger l\'AR24</a></li><li role="menuitem" ng-if="$ctrl.transaction.contrat_reservation_id !== 0\r\n              && ($ctrl.transaction.signature_procedure_status === 0 ||\r\n          $ctrl.transaction.signature_procedure_status === -30 ||\r\n          $ctrl.transaction.signature_procedure_status === -20)"> <a title="Reg\xE9n\xE9rer le contrat" tooltip-placement="top" uib-tooltip="Fonctionnalit\xE9 non activ\xE9e" tooltip-enable="!$ctrl.configCommercialisateursTransactions.contrat_reservation_generate_enabled" ng-disabled="!$ctrl.configCommercialisateursTransactions.contrat_reservation_generate_enabled" ng-click="$event.stopPropagation();$ctrl.modalStartContrat($ctrl.transaction, true, \'signature-btn\')">Reg\xE9n\xE9rer le contrat</a></li><li role="menuitem" ng-if="$ctrl.transaction.signature_procedure_status === 0 && $ctrl.transaction.contrat_reservation_id && !$ctrl.btnSignatureDisabled"> <a ng-click="$event.stopPropagation();$ctrl.signature($ctrl.transaction)" tooltip-placement="top" uib-tooltip="Fonctionnalit\xE9 non activ\xE9e" tooltip-enable="!$ctrl.configCommercialisateursTransactions.contrat_reservation_signature_enabled" ng-disabled="!$ctrl.configCommercialisateursTransactions.contrat_reservation_signature_enabled || $ctrl.transaction.processus_generating !== 50">D\xE9marrer la signature</a></li><li ng-if="$root.env !== \'immodesk\' &&\r\n          ($ctrl.myValidator && $ctrl.myValidator.status === \'active\' && $ctrl.transaction.signature_procedure_status === 20)\r\n      || ($ctrl.myReservant && $ctrl.myReservant.status === \'active\' && $ctrl.transaction.signature_procedure_status === 30)"> <a ng-click="$event.stopPropagation();$ctrl.openModalContrat($ctrl.transaction)">Valider/Refuser le contrat</a></li><li role="menuitem" ng-if="$ctrl.transaction.signature_procedure_status > 0 &&\r\n        $ctrl.transaction.signature_procedure_status <= 30 &&\r\n        $ctrl.transaction.contrat_reservation_id"> <a ng-click="$event.stopPropagation();$ctrl.modalAbandonnerSignature($ctrl.transaction)" tooltip-placement="top" uib-tooltip="Fonctionnalit\xE9 non activ\xE9e" tooltip-enable="!$ctrl.configCommercialisateursTransactions.contrat_reservation_signature_enabled" ng-disabled="!$ctrl.configCommercialisateursTransactions.contrat_reservation_signature_enabled">Annuler contrat et signature</a></li></ul><ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="button-signature" ng-if="$ctrl.transaction.signature_programme_unlatch === true"><li role="menuitem" ng-disabled="$ctrl.transaction.loadingUnlatch"> <a ng-click="$event.stopPropagation();$ctrl.signatureEResa($ctrl.transaction)" tooltip-placement="top">E-resa</a></li></ul></div></div><div ng-if="$ctrl.transaction.contrat_reservation_id !== 0 && $ctrl.transaction.signature_procedure_status == 2" class="d-flex"> Contrat sign\xE9 import\xE9 le {{$ctrl.transaction.contrat_date_initialisation.date | moment:\'DD/MM/YYYY\'}}</div>');}]);